var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import aMapDriveRouteByServer from '../core/amap/driveRouteByServer';
import lbsDriveRouteByServer from '../core/lbs/driveRouteByServer';
import { mergeOptions, mergeParams, noCacheOptions, services, } from '../core/utils';
import { isLbsResponseExist } from '../core/utils/is';
import { mapError } from '../core/utils/logger';
/**
 * 驾车路径规划
 * @group 方法
 */
function driveRouteByServer(params, options) {
    return __awaiter(this, void 0, void 0, function () {
        var _options, _params, _a, firstRequest, lastRequest, _noCacheOptions, result, exist, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _options = mergeOptions('driveRouteByServer', options);
                    _params = mergeParams({
                        // 驾车选择策略
                        strategy: 10,
                        // `steps`字段为空
                        pathType: 0,
                        // 返回基础信息
                        extensions: 0,
                    }, params);
                    _a = services(lbsDriveRouteByServer, aMapDriveRouteByServer, _options), firstRequest = _a[0], lastRequest = _a[1];
                    _noCacheOptions = noCacheOptions(_options);
                    if (!lastRequest) return [3 /*break*/, 5];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, firstRequest(_params, _options)];
                case 2:
                    result = _b.sent();
                    exist = isLbsResponseExist(result);
                    if (exist)
                        return [2 /*return*/, result];
                    return [2 /*return*/, lastRequest(_params, _noCacheOptions)];
                case 3:
                    e_1 = _b.sent();
                    mapError('(驾车路径规划)降级', [e_1]);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, lastRequest(_params, _noCacheOptions)];
                case 5: return [2 /*return*/, firstRequest(_params, _options)];
            }
        });
    });
}
export default driveRouteByServer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGJzRHJpdmVSb3V0ZUJ5U2VydmVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sc0JBQXNCLE1BQU0saUNBQWlDLENBQUM7QUFDckUsT0FBTyxxQkFBcUIsTUFBTSxnQ0FBZ0MsQ0FBQztBQUtuRSxPQUFPLEVBQ0wsWUFBWSxFQUNaLFdBQVcsRUFDWCxjQUFjLEVBQ2QsUUFBUSxHQUNULE1BQU0sZUFBZSxDQUFDO0FBQ3ZCLE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ3RELE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxzQkFBc0IsQ0FBQztBQUdoRDs7O0dBR0c7QUFDSCxTQUFlLGtCQUFrQixDQUMvQixNQUFnQyxFQUNoQyxPQUFvQjs7Ozs7O29CQUVkLFFBQVEsR0FBRyxZQUFZLENBQUMsb0JBQW9CLEVBQUUsT0FBTyxDQUFDLENBQUM7b0JBQ3ZELE9BQU8sR0FBRyxXQUFXLENBQ3pCO3dCQUNFLFNBQVM7d0JBQ1QsUUFBUSxFQUFFLEVBQUU7d0JBQ1osY0FBYzt3QkFDZCxRQUFRLEVBQUUsQ0FBQzt3QkFDWCxTQUFTO3dCQUNULFVBQVUsRUFBRSxDQUFDO3FCQUNkLEVBQ0QsTUFBTSxDQUNQLENBQUM7b0JBQ0ksS0FBOEIsUUFBUSxDQUMxQyxxQkFBcUIsRUFDckIsc0JBQXNCLEVBQ3RCLFFBQVEsQ0FDVCxFQUpNLFlBQVksUUFBQSxFQUFFLFdBQVcsUUFBQSxDQUk5QjtvQkFDSSxlQUFlLEdBQUcsY0FBYyxDQUFDLFFBQVEsQ0FBQyxDQUFDO3lCQUU3QyxXQUFXLEVBQVgsd0JBQVc7Ozs7b0JBRUkscUJBQU0sWUFBWSxDQUFDLE9BQU8sRUFBRSxRQUFRLENBQUMsRUFBQTs7b0JBQTlDLE1BQU0sR0FBRyxTQUFxQztvQkFDOUMsS0FBSyxHQUFHLGtCQUFrQixDQUFDLE1BQU0sQ0FBQyxDQUFDO29CQUN6QyxJQUFJLEtBQUs7d0JBQUUsc0JBQU8sTUFBTSxFQUFDO29CQUV6QixzQkFBTyxXQUFXLENBQUMsT0FBTyxFQUFFLGVBQWUsQ0FBQyxFQUFDOzs7b0JBRTdDLFFBQVEsQ0FBQyxZQUFZLEVBQUUsQ0FBQyxHQUFDLENBQUMsQ0FBQyxDQUFDOzt3QkFHOUIsc0JBQU8sV0FBVyxDQUFDLE9BQU8sRUFBRSxlQUFlLENBQUMsRUFBQzt3QkFHL0Msc0JBQU8sWUFBWSxDQUFDLE9BQU8sRUFBRSxRQUFRLENBQUMsRUFBQzs7OztDQUN4QztBQUVELGVBQWUsa0JBQWtCLENBQUMifQ==